<template>
  <div class="fg-container series-details" v-if="has_store_data">
    <div class="bg-blue">
      <Breadcrumbs
        :currentSeriesObj="getcurrentSeriesObj()"
        :currentSeries="selected_series"
        :forceSlice="forceSlice"
        :sequence="[
          {type: 'base', page: 'home'},
          {type: 'module', module: forceSlice, isforceSlice: true},
          {type: 'param', param: 'series_slug'},
          {type: 'page', page: tabName}
        ]"
      />
      <div class="waf-head" v-if="isSeriesLoaded">
        <div class="sports-name">
          <span>{{ seriesSportName }}</span>
        </div>
        <h1 class="title">{{ seriesName }}{{ pageType }}</h1>
        <div class="series-duration">
          <p v-if="seriesDesc">
            <strong>{{seriesDesc}}</strong>
          </p>
          <p>
            <span>{{ seriesDuration }}</span>
            <span class="num-matches">{{ totalMatches }} matches</span>
          </p>
        </div>
      </div>
    </div>
    <div class="dropdown-tab" v-if="isSeriesLoaded">
      <div class="select-wrap">
        <ul>
          <li
            v-for="t in tabsArr"
            v-bind:key="t.id"
            :class="[
              'no-select',
              { active: t.id === selectedTabId },
              { 'btn-disabled': t.isDisabled },
            ]"
          >
            <a v-if="!t.isDisabled && t.tabUrl" :href="t.tabUrl">
              <span>{{ t.displayName }}</span>
            </a>
            <span v-else>{{ t.displayName }}</span>
          </li>
          <li v-if="listingPages && listingPages.length" :class="['submenu', {'active': moreOpened}]" @click="onMoreToggle()">
            <span class="more">More</span>
            <ul class="submenu-list">
              <li
                v-for="(t, t_idx) in listingPages"
                v-bind:key="t_idx"
              >
                <a v-if="t.pageUrl" :href="t.pageUrl"><span>{{t.displayName}}</span></a>
                <span v-else>{{t.displayName}}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="roi-component" v-else>
      <div class="no-data">
        <p class="msg">No information available for this series.</p>
      </div>
    </div>
    <div
      :class="[
        { 'match-result match-card-listing': hasMatchesData },
        { 'no-data': !hasMatchesData },
      ]"
      v-if="
        isSeriesLoaded &&
        (selectedTabId == tabIds.result || selectedTabId == tabIds.upcoming)
      "
    >
      <!-- <gamezy-ad size="mob_small" ad_id="mob_small-ad-2" :autoDetect="true" /> -->
      <!-- <gamezy-ad size="web_small" ad_id="web_small-ad-2" :autoDetect="true" /> -->
      <p class="msg" v-if="!hasMatchesData">
        No matches available.
      </p>
      <p class="msg" v-if="isOtherTabHasMatches">
        {{isOtherTabHasMatches.preText}}
        <a class="no-data-link" :href="isOtherTabHasMatches.linkUrl">{{isOtherTabHasMatches.linkLabel}}</a>
        {{isOtherTabHasMatches.postText}}
      </p>
      <article
        v-for="(m, m_idx) in matchList"
        :key="m_idx"
        :class="[
          'article-item',
          'match-card',
          'item-type-article',
          { 'btn-disabled': (m.status == 0 || m.status == -1) },
        ]"
        :data-matchcode="m.match_code"
      >
        <series-fixture v-if="(m.status == 0 || m.status == -1)" :match="m" />
        <a :href="getMatchLink(m)" v-else>
          <series-fixture :match="m" />
        </a>
      </article>
    </div>
    <points-table
      v-if="tabIds.ptsTable == selectedTabId"
      :hasPointsTable="hasPointsTable"
      :tableData="pointsTable"
      :pageOptionForNoPtsTable="pageOptionForNoPtsTable"
    />
  </div>
</template>

<script>
import SeriesFixture from "./SeriesFixture";
import PointsTable from "./PointsTable";
import Breadcrumbs from "../common/Breadcrumbs";
import SeriesLandingModule from "../../store/modules/seriesListing/seriesLanding";
import { cssImport, formatFullUrl, urlCorrections } from "../../assets/js/common";
import { CFG_MODULES } from "../../assets/js/config";
// import GamezyAd from '../common/GamezyAd';
export default {
  props: ["pageHeadKey", "tabName"],
  components: {
    SeriesFixture,
    PointsTable,
    Breadcrumbs,
    // GamezyAd,
  },
  data() {
    return {
      forceSlice: CFG_MODULES.SCHEDULE.route,
      moreOpened: false
    };
  },
  computed: {
    has_store_data() {
      return !!(
        this.$store.state &&
        this.$store.state.serieslanding &&
        this.$store.state.serieslanding.landing_store_filled
      );
    },
    translations() {
      return this.$store.state.translations;
    },
    tabIds() {
      return this.$store.state.serieslanding.tabIds;
    },
    selectedTabId: {
      get: function () {
        return this.$store.state.serieslanding.selectedTabId;
      },
      set: function (new_id) {
        this.$store.state.serieslanding.selectedTabId = new_id;
      },
    },
    is_mobile_view() {
      return this.$store.state.ismobile;
    },
    selected_series() {
      return this.$store.state.serieslanding.selected_series;
    },
    isSeriesLoaded() {
      return this.selected_series && this.selected_series != -1;
    },
    seriesName() {
      return this.$store.state.serieslanding.seriesName;
    },
    matchNameYear() {
      return this.$store.state.serieslanding.matchNameYear;
    },
    seriesSportName() {
      return this.$store.state.serieslanding.seriesSportName;
    },
    seriesSportId() {
      return this.$store.state.serieslanding.seriesSportId;
    },
    totalMatches() {
      return this.$store.state.serieslanding.totalMatches;
    },
    totalTeams() {
      return this.$store.state.serieslanding.totalTeams;
    },
    seriesDuration() {
      return this.$store.state.serieslanding.seriesDuration;
    },
    resultMatches() {
      return this.$store.state.serieslanding.resultMatches;
    },
    upcomingMatches() {
      return this.$store.state.serieslanding.upcomingMatches;
    },
    pointsTable() {
      return this.$store.state.serieslanding.pointsTable;
    },
    hasPointsTable() {
      return (
        this.$store.state.serieslanding.pointsTable &&
        this.$store.state.serieslanding.pointsTable.length
      );
    },
    pageType() {
      let descObj = this.translations.seriesDesc[this.selectedTabId];
      return (descObj && descObj.heading) ? ` : ${descObj.heading}` : "";
    },
    seriesDesc() {
      let descObj = this.translations.seriesDesc[this.selectedTabId] || this.translations.seriesDesc["2"];
      let transVal = (this.totalTeams && this.totalTeams>2) ? descObj.tour : descObj.bilateral;
      if(transVal) {
        return transVal
          .replace(/{{series_name}}/g, this.seriesName)
          .replace(/{{matchNameYear}}/g, this.matchNameYear);
      } else {
        return null;
      }
    },
    tabsArr() {
      let seriesSlug = this.$route.params.series_slug;
      let urlBase = `/${seriesSlug}`;
      let tabs = [
        {
          displayName: "Results",
          id: 1,
          linkLabel: "past matches",
          tabUrl: (urlBase ? urlCorrections(`${urlBase}/result`) : null),
          isDisabled: !(this.resultMatches && this.resultMatches.length),
        },
        {
          displayName: "Matches",
          id: 2,
          linkLabel: "upcoming matches",
          tabUrl: (urlBase || null),
          isDisabled: !(this.upcomingMatches && this.upcomingMatches.length),
        },
        {
          displayName: "Points Table",
          id: 3,
          linkLabel: "points table",
          tabUrl: (urlBase ? urlCorrections(`${urlBase}/points-table`) : null),
          isDisabled: !this.hasPointsTable,
        },
      ];
      return tabs;
    },
    matchList() {
      if (this.selectedTabId == this.tabIds.result) {
        return this.resultMatches;
      } else if (this.selectedTabId == this.tabIds.upcoming) {
        return this.upcomingMatches;
      } else {
        return [];
      }
    },
    listingPages() {
      let seriesSlug = this.$route.params.series_slug;
      let urlBase = `/${seriesSlug}`;
      let {GAME_PLAN, LINEUP, MATCH_INFO, TEAM_HTOH, PLAYER_HTOH} = CFG_MODULES;
      let list = [];
      if(GAME_PLAN) {
        list.push({
          displayName: GAME_PLAN.breadcrumbName,
          pageUrl: urlBase ? urlCorrections(`${urlBase}${GAME_PLAN.route}`) : null
        })
      }
      if(LINEUP) {
        list.push({
          displayName: LINEUP.breadcrumbName,
          pageUrl: urlBase ? urlCorrections(`${urlBase}${LINEUP.route}`) : null
        })
      }
      if(MATCH_INFO && this.seriesSportId==1) {
        list.push({
          displayName: MATCH_INFO.breadcrumbName,
          pageUrl: urlBase ? urlCorrections(`${urlBase}${MATCH_INFO.route}`) : null
        })
      }
      if(TEAM_HTOH && this.seriesSportId==1) {
        list.push({
          displayName: TEAM_HTOH.breadcrumbName,
          pageUrl: urlBase ? urlCorrections(`${urlBase}${TEAM_HTOH.route}`) : null
        })
      }
      if(PLAYER_HTOH && this.seriesSportId==1) {
        list.push({
          displayName: PLAYER_HTOH.breadcrumbName,
          pageUrl: urlBase ? urlCorrections(`${urlBase}${PLAYER_HTOH.route}`) : null
        })
      }
      return list;
    },
    hasMatchesData() {
      return !!(this.matchList && this.matchList.length);
    },
    isOtherTabHasMatches() {
      let expectedTab = null;
      if(!this.hasMatchesData) {
        if ((this.selectedTabId == this.tabIds.result) && (this.upcomingMatches && this.upcomingMatches.length)) {
          expectedTab = this.tabIds.upcoming;
        } else if ((this.selectedTabId == this.tabIds.upcoming) && (this.resultMatches && this.resultMatches.length)) {
          expectedTab = this.tabIds.result;
        }
      }

      if(expectedTab) {
        return this.getOtherLinkObj(expectedTab);
      } else {
        return null;
      }
    },
    pageOptionForNoPtsTable() {
      let expectedTab = null;
      if(!this.hasPointsTable) {
        if(this.upcomingMatches && this.upcomingMatches.length) {
          expectedTab = this.tabIds.upcoming;
        } else if(this.resultMatches && this.resultMatches.length) {
          expectedTab = this.tabIds.result;
        }
      }

      if(expectedTab) {
        return this.getOtherLinkObj(expectedTab);
      } else {
        return null;
      }
    }
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    this.$store.registerModule("serieslanding", SeriesLandingModule);
    return await this.$store.dispatch("serieslanding/fetchSeriesInfo", {tabName: this.tabName});
  },
  beforeMount() {
    this.registerSeriesLandingModule();
  },
  mounted() {
    let hasStore = this.has_store_data;
    cssImport([
      "/static-assets/css/fg-top-widget.css",
      "/static-assets/css/series-details.css",
    ]);
    if (!hasStore) {
      this.initApis(hasStore);
    }
  },
  methods: {
    async registerSeriesLandingModule() {
      let hasSeriesLandingModule = this.$store.hasModule("serieslanding");
      if (!hasSeriesLandingModule) {
        this.$store.registerModule("serieslanding", SeriesLandingModule, {
          preserveState: this.has_store_data,
        });
      }
    },
    async initApis(hasStore) {
      if (!hasStore) {
        await this.$store.dispatch("serieslanding/fetchSeriesInfo", {tabName: this.tabName});
      }
    },
    getcurrentSeriesObj() {
      return {
        category_name: this.seriesName,
      };
    },
    setNewTab(newTabId, disabledClick) {
      this.moreOpened = false;
      if (!disabledClick && this.selectedTabId != newTabId) {
        this.selectedTabId = newTabId;
      }
    },
    getMatchLink(m) {
      if (m.status === 0 || m.status === -1) {
        return null;
      } else if(m.status !== 1 || m.match_state === 'c') {
        if(m.slug) {
          let pageRoute = CFG_MODULES.SCORECARD.route;
          let matchUrl = formatFullUrl(m, pageRoute);
          return matchUrl;
        } else {
          return null;
        }
      } else {
        if (m.slug) {
          let pageRoute =
            m.sport_id == 2
              ? CFG_MODULES.LINEUP.route
              : CFG_MODULES.MATCH_INFO.route;
          let matchUrl = formatFullUrl(m, pageRoute);
          return matchUrl;
        } else {
          return null;
        }
      }
    },
    onMoreToggle() {
      this.moreOpened = !this.moreOpened;
    },
    getOtherLinkObj(tabId) {
      let tab = this.tabsArr.find(t => t.id === tabId);
      if(tab) {
        return {
          preText: "There are some ",
          postText: " available for this series, you can check them.",
          linkUrl: tab.tabUrl,
          linkLabel: tab.linkLabel
        }
      } else {
        return null;
      }
    }
  },
  beforeDestroy() {
    this.$store.unregisterModule("serieslanding");
  },
};
</script>